import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=21d4d846&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d4d846')) {
      api.createRecord('21d4d846', component.options)
    } else {
      api.reload('21d4d846', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=21d4d846&", function () {
      api.rerender('21d4d846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I2Dc2I9z5pZB/JS/comp/ImgFallback2.vue"
export default component.exports